import {combineReducers} from 'redux';
import accountReducers from './accountReducers/accountReducers';

export const rootReducer = combineReducers({
  dataLogin: accountReducers,
});



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js